import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { DevicesRouterStoreSelectors } from '../router';

import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { DeviceLocationStoreActions } from './index';

@Injectable({ providedIn: 'root' })
export class DeviceLocationResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        if (udid) {
          this.store.dispatch(
            DeviceLocationStoreActions.DeviceLocationResolverActions.deviceLocationRequested({
              udid: udid,
            })
          );
        }
      }),
      map(() => true),
      first()
    );
  }
}
